import * as React from 'react';
import { Button, Icon } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { IData } from './IModels';
import SearchDialog, { OnSaveResult } from './SearchDialog';

interface IProps {
	showGridTabs: string,

	kinds: (keyof IData)[],
	filterId: string,
	relatedFilterId: string,

	notifier: { value: string, label: string },

	gridColumns: any,
	relatedGridColumns: any,

	onSave: (r: OnSaveResult) => void,
	className: string,
	disabled: boolean,
	manageFiltersPermission: boolean,
}

export default function SearchButton(props: React.PropsWithChildren<IProps>) {
	const [open, setOpen] = React.useState(false);
	const { t } = useTranslation();

	return <>
		{props.showGridTabs !== 'hidden' && <Button
			disabled={props.disabled}
			className={props.className}
			variant="outlined"
			onClick={() => setOpen(true)}
			startIcon={<Icon>add_circle</Icon>}
		>
			{t("common.action.select")}
		</Button>}
		{open && <SearchDialog {...props} onClose={() => setOpen(false)} />}
	</>
}